import React from "react";
import ReactDOM from "react-dom";
import EventListPage from "../components/event/EventListPage";
import { initializeI18n } from '../localization/i18n';

window.renderEvent = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<EventListPage props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering Event:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};
